import React from "react";
import {
  TableHead,
  TableCell,
  TableSortLabel,
  Stack,
  TableRow,
  Checkbox,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { HubIcon } from "../../HubIcon";
import { StyledTableCell } from "./styles";

const flippedSo = {
  asc: "desc",
  desc: "asc",
};

export const HubTableHeader = ({
  items = [],
  onChange = () => {},
  includeCheckbox = true,
  includeChevron = false,
  includeEnd = true,
  prefix = "",
  sx = { backgroundColor: "hubColors.greyLighter" },
  tableRowProps = {},
  onSelectAll,
  selectedAll = false,
  ...rest
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const orderLabel = `${prefix}orderBy`;
  const sortOrderLabel = `${prefix}sortOrder`;

  const query = new URLSearchParams(location.search);

  const orderBy = query.get(orderLabel);
  const sortOrder = query.get(sortOrderLabel);

  const handleSort = (id) => {
    const isAsc = orderBy === id && sortOrder === "asc";
    const newSortOrder = isAsc ? "desc" : "asc";

    query.set(orderLabel, id);
    query.set(sortOrderLabel, newSortOrder);

    navigate({
      pathname: location.pathname,
      search: query.toString(),
    });

    onChange();
  };

  return (
    <TableHead sx={sx} {...rest}>
      <TableRow
        sx={{
          "& .MuiTableCell-root": { py: "4px !important" },
        }}
        {...tableRowProps}
      >
        {includeCheckbox && (
          <TableCell variant="small">
            {onSelectAll && (
              <Checkbox
                sx={{ padding: 0, backgroundColor: "hubColors.white" }}
                onClick={onSelectAll}
                checked={selectedAll}
              />
            )}
          </TableCell>
        )}
        {includeChevron && <TableCell variant="small" />}
        {items?.map((item) => (
          <StyledTableCell key={item?.id}>
            <Stack direction="row" gap="7px" alignItems="center">
              {item?.icon && <HubIcon icon={item?.icon} size="12px" />}
              {item?.sortable ? (
                <TableSortLabel
                  active={orderBy === item?.id}
                  direction={orderBy === item?.id ? sortOrder : "desc"}
                  onClick={() => handleSort(item?.id)}
                >
                  {item?.label}
                </TableSortLabel>
              ) : (
                item?.label
              )}
            </Stack>
          </StyledTableCell>
        ))}
        {includeEnd && <TableCell variant="small" />}
      </TableRow>
    </TableHead>
  );
};

export default HubTableHeader;
